$(document).foundation();

jQuery(document).ready(function($) {

  // open links in new tab not same domain
  var all_links = document.querySelectorAll('a');
  for (var i = 0; i < all_links.length; i++){
    var a = all_links[i];
    if(a.hostname != location.hostname) {
      a.rel = 'noopener';
      a.target = '_blank';
    }
  }

  // height
  $('.hero').css({ height: window.innerHeight })

  // nav - open contact
  $('nav li.contact-toggle, .mobile-toggle').on('click', function(e) {
    $('body').toggleClass('nav--menu--is-open')
    $('header').animate({ scrollTop: 0 }, 300)
    e.preventDefault()
    e.stopPropagation()
  })

  // nav - contact mobile open
  $('nav li.contact-toggle-mobile').on('click', function(e) {
    $('body').toggleClass('contact-pane-mobile--is-open')
    e.preventDefault()
    e.stopPropagation()
    if ($('body').hasClass('contact-pane-mobile--is-open')) {
      $('header').animate({ scrollTop: $(window).height() / 2 }, 250)
    } else {
      $('header').animate({ scrollTop: 0 }, 250)
    }
  })

  // portfolio
  $('.single-portfolio .description .read-more').on('click', function(e) {
    $('.single-portfolio .brief-description').toggleClass('hide')
    $('.single-portfolio .full-description').toggleClass('hide')
    e.preventDefault()
  })

  // services
  var $carouselPayloads;

  // services switch types
  $('.services .types li').on('click', function(e) {
    var index = $(this).index()
    $('.services .types li a').removeClass('active')
    $('.services .types li').eq(index).find('a').addClass('active')
    $('.services .images img').each(function() {
      if ($(this).index() > index) {
        $(this).removeClass('active')
      }
    })
    $('.services .images img').eq(index).addClass('active')
    $carouselPayloads.flickity('select', index)

    e.preventDefault()
  })

  // services payloads
  $carouselPayloads = $('.carousel-payloads').flickity({
    cellSelector: '.carousel-cell',
    prevNextButtons: false,
    pageDots: false,
    imagesLoaded: true,
    fade: true,
    draggable: false,
    autoPlay: false,
    selectedAttraction: 0.2,
    friction: 0.8,
    adaptiveHeight: true,
    on: {
      ready: function() {

      }
    }
  })

  $('.payloads .accordion').on('down.zf.accordion', function(e) {
    $carouselPayloads.flickity('resize')
    ScrollTrigger.refresh(true)
  })

  $('.payloads .accordion').on('up.zf.accordion', function(e) {
    $carouselPayloads.flickity('resize')
    ScrollTrigger.refresh(true)
  })

  $('.services .types li').first().find('a').trigger('click')

  $('.payloads .set-filter h3 a').on('click', function(e) {
    var $carouselCell = $(this).closest('.carousel-cell')
    var $h3 = $(this).closest('h3')
    var $a = $h3.find('a')
    if ($h3.hasClass('set-filter--is-showing')) {
      $('.payloads .set-filter h3:not(.set-filter--is-showing)').toggleClass('set-filter--is-showing-temporarily')
    } else if ($h3.hasClass('set-filter--is-showing-temporarily')) {
      $('.payloads .set-filter h3').removeClass('set-filter--is-showing').removeClass('set-filter--is-showing-temporarily')
      $h3.addClass('set-filter--is-showing')
      var set = $a.attr('href').replace('#', '')
      $carouselCell.find('.set-accordion').removeClass('set-accordion--is-showing')
      $carouselCell.find('.set-accordion.' + set).addClass('set-accordion--is-showing')
    }
    e.preventDefault()

  })

  // profile
  var $carouselBios;

  // profile switch types
  $('.names .types li').on('click', function(e) {
    var index = $(this).index()
    $('.names .types li a').removeClass('active')
    $('.names .types li').eq(index).find('a').addClass('active')
    $('.names .images img').each(function() {
      if ($(this).index() > index) {
        $(this).removeClass('active')
      }
    })
    $('.names .images img').eq(index).addClass('active')
    $carouselBios.flickity('select', index)
    e.preventDefault()
  })

  // profile bios
  $carouselBios = $('.carousel-bios').flickity({
    cellSelector: '.carousel-cell',
    prevNextButtons: false,
    pageDots: false,
    imagesLoaded: true,
    fade: true,
    draggable: false,
    autoPlay: false,
    selectedAttraction: 0.2,
    friction: 0.8,
    adaptiveHeight: Foundation.MediaQuery.current == 'small'
  })

  $('.names .types li').first().find('a').trigger('click')

  // filters
  $('.filters a').on('click', function(e) {
    $('.filters').toggleClass('filters--is-open')
    e.preventDefault()
  })
  $('.filters').hover(
    function() {},
    function() {
      $('.filters').removeClass('filters--is-open')
      ScrollTrigger.refresh(true)
    }
  )

  $('.filters .type').on('click', function() {
    var $type = $(this)
    var typeName = $type.find('.type-name').html()
    var typeData = $type.find('.type-name').data('type')
    $('.filters h3 a').html(typeName)
    if (typeName == 'all') {
      $('.thumbnails .cell').removeClass('hide')
      $('.filters').addClass('filters-type-all')
    } else {
      $('.filters').removeClass('filters-type-all')
      $('.thumbnails').addClass('thumbnails--is-hidden')
      $('.thumbnails .cell').addClass('hide').each(function() {
        if ($(this).data('type').indexOf(typeData) > -1) {
          $(this).removeClass('hide')
        }
      })
    }
    $('.thumbnails').removeClass('thumbnails--is-hidden')
    if (Foundation.MediaQuery.current == 'small') {
      $('.filters').removeClass('filters--is-open')
    }
    ScrollTrigger.refresh(true)
  })

  // homepage hero carousel
  function updateDotsPage(index) {
    $('.counter span').removeClass('active').eq(index).addClass('active')
    var $carouselCell = $('.carousel-home .carousel-cell').eq(index)
    if ($carouselCell.data('page-dark') == 1) {
      $('body').addClass('page-dark')
    } else {
      $('body').removeClass('page-dark')
    }
  }

  $('.carousel-home').imagesLoaded( { background: '.image' }, function() {
    var randomStartingIndex = Math.floor(Math.random() * $('.carousel-home .carousel-cell').length)
    var $carouselHome = $('.carousel-home').flickity({
      cellSelector: '.carousel-cell',
      autoPlay: 4500,
      prevNextButtons: false,
      pageDots: false,
      imagesLoaded: true,
      fade: true,
      setGallerySize: false,
      wrapAround: true,
      draggable: false,
      pauseAutoPlayOnHover: false,
      initialIndex: randomStartingIndex,
      on: {
        change: function(index) {
          updateDotsPage(index)
        },
        ready: function() {
          updateDotsPage(randomStartingIndex)
          setTimeout(function() {
            $('.hero-home').addClass('hero-home--is-showing')
          }, 250)
        }
      }
    })
  })

  // nav - move w on large screens
  if (Foundation.MediaQuery.is('large up')) {
    var scrollTriggerSettings = {
      trigger: '.hero',
      start: 'top top',
      end: '50% top',
      scrub: 0.5,
      markers: false
    }
    if ($('.single-post').length > 0) {
      scrollTriggerSettings.trigger = '.main-image'
    }
    if ($('.page-template-page-news').length > 0) {
      scrollTriggerSettings.trigger = '.filters'
      scrollTriggerSettings.end = '100% top'
    }
    gsap.timeline({
      scrollTrigger: scrollTriggerSettings
    })
    .to('header .icon-logo', { opacity: 0 }, 0)
    .to('header .icon-w-moving', { opacity: 1 }, 0)
    .to('header .icon-w-moving', { x: 150 })
  }

  // hero - move text
  if ($('.single-portfolio').length > 0) {
  var headlineSplitText = new SplitText($('.hero .headline-container p'), {type:"lines"})
    gsap.timeline({
      scrollTrigger: {
        trigger: '.hero',
        start: '10% top',
        end: 'bottom top',
        scrub: 0.5,
        markers: false
      }
    })
    .to(headlineSplitText.lines, { xPercent: -25, stagger: 0.05 })
  } else {
    gsap.timeline({
      scrollTrigger: {
        trigger: '.hero',
        start: '10% top',
        end: 'bottom top',
        scrub: 0.5,
        markers: false
      }
    })
    .to('.hero .headline-container p span', { xPercent: -25, stagger: 0.05 })
  }

  // nav - black text + white page
  if ($('main.has-hero-image').length > 0) {
    gsap.timeline({
      scrollTrigger: {
        trigger: 'main.has-hero-image',
        start: '-110 top',
        end: '50% 50%',
        scrub: 0.5,
        markers: false
      }
    })
    .to('.body', { opacity: 1,
      onStart: function() {
        $('body').addClass('page-scroll-nav-dark')
        $('body').addClass('page-white')
      },
      onReverseComplete: function() {
        $('body').removeClass('page-scroll-nav-dark')
        $('body').removeClass('page-white')
      }
    })
  } else {
    gsap.timeline({
      scrollTrigger: {
        trigger: 'main',
        start: 'top 50%',
        end: '50% 50%',
        scrub: 0.5,
        markers: false
      }
    })
    .to('.body', { opacity: 1,
      onStart: function() {
        $('body').addClass('page-scroll-nav-dark')
        $('body').addClass('page-white')
      },
      onReverseComplete: function() {
        $('body').removeClass('page-scroll-nav-dark')
        $('body').removeClass('page-white')
      }
    })
  }

  // animation of content
  $('.content-move-fade').each(function() {
    var $content = $(this)
    var scrollTriggerSettings = {
      trigger: $content,
      start: 'top 90%',
      end: 'top 30%',
      scrub: 0.5,
      markers: false
    }
    if (Foundation.MediaQuery.is('medium down')) {
      scrollTriggerSettings.end = 'top 50%'
    }
    if ($content.hasClass('content-move-fade-services-payloads')) {
      scrollTriggerSettings.start = '-50px 100%'
      scrollTriggerSettings.end = 'top 97%'
    }
    var tl = gsap.timeline({
      scrollTrigger: scrollTriggerSettings
    })
    .from($content, { y: 100, opacity: 0 } )
  })

  // brand partners - turn page black
  if ($('.brand-partners').length > 0) {
    gsap.timeline({
      scrollTrigger: {
        trigger: '.brand-partners',
        start: 'top 30%',
        end: '250px 20%',
        scrub: 0.5,
        markers: false
      }
    })
    .to('.body', { opacity: 1,
      onStart: function() {
        $('body').addClass('page-gray').removeClass(' page-scroll-nav-dark')
      },
      onReverseComplete: function() {
        $('body').removeClass('page-gray').addClass(' page-scroll-nav-dark')
      }
    })
  }

  // Adds Flex Video to YouTube and Vimeo Embeds
  $('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
    $(this).parent().addClass('responsive-embed widescreen')
  })

})
